import { Component, Renderer2, RendererFactory2 } from '@angular/core';
import { Event, Router, NavigationStart, NavigationCancel, NavigationEnd, NavigationError, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { LoaderService } from './core/services/loader/loader.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = environment.title;
  environmentConfig = environment;
  private renderer: Renderer2;
  
  constructor(private router: Router, private loaderService: LoaderService, private gaService: GoogleAnalyticsService, private titleService: Title, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.setFavicon();
    this.titleService.setTitle(this.title);
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loaderService.show();
          break;
        }

        case event instanceof NavigationEnd: {
          try {
            const currentRoute: any = this.router.routerState.root;
            const componentName = this.getComponentName(currentRoute);
            this.gaService.sendAnalytics("page_view", {
              page_title: componentName,
            });
          } catch {}
        }
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loaderService.hide();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  private getComponentName(route: ActivatedRouteSnapshot): string {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.routeConfig?.component?.name || "";
  }

  private setFavicon() {
    const link: HTMLLinkElement =
      this.renderer.createElement('link');
    link.rel = 'icon';
    link.href = environment.faviconSrc;
    const head = this.renderer.selectRootElement('head', true);
    this.renderer.appendChild(head, link);
  }
}
